import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { probeFomwareCredential } from '/imports/api/fomwareMeters';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';
import { FormField } from '/imports/ui/FormField';
import { Input } from '/imports/ui/Input';
import { Select } from '/imports/ui/Select';
import { FomwareApiVersion, fomwareApiVersions } from '/imports/api/fomwareMeters';

const apiVersionOptions = fomwareApiVersions.map((v) => ({ value: v, label: v }));

/** Dev tool: verify a FOMware base URL + API token, and sample a day of interval data from the first site. */
export const DevToolFomwareProbe = () => {
  const [baseUrl, setBaseUrl] = useState('https://api.fomware.com');
  const [token, setToken] = useState('');
  const [apiVersion, setApiVersion] = useState<FomwareApiVersion>('v2');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const run = toastOnError(async () => {
    if (!token || loading) return;
    setLoading(true);
    setResult('');
    try {
      const res = await probeFomwareCredential.call({ baseUrl: baseUrl || undefined, apiVersion, token });
      setResult(JSON.stringify(res, null, 2));
      if (res.ok) toast.success(`${res.sites} sites · ${res.sample?.intervals || 0} intervals sampled`);
      else toast.error(res.message || 'FOMware probe failed');
    }
    finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection
      title="FOMware Probe"
      description="Check a FOMware <b>Base URL</b> + <b>API Token</b>: lists sites, then samples the last 2 days of 15-minute interval data from the first site. Use this to confirm the credential works — and to sanity-check the interval timestamps — before wiring meters to it. The token is not stored."
      onRun={() => run()}
      buttonText={loading ? 'Probing…' : 'Probe'}
      loading={loading}
    >
      <FormField field="baseUrl">
        <label>Base URL</label>
        <Input value={baseUrl} onChange={(v) => setBaseUrl(v || '')} />
      </FormField>
      <FormField field="apiVersion">
        <label>API Version</label>
        <Select value={apiVersion} options={apiVersionOptions} onChange={(v) => setApiVersion(v as FomwareApiVersion)} />
      </FormField>
      <FormField field="token">
        <label>API Token</label>
        <Input value={token} type="password" onChange={(v) => setToken(v || '')} />
      </FormField>
      {result && <pre>{result}</pre> || null}
    </DevToolSection>
  );
};
